import { Color } from '@app/shared/models/color.model';
import { Component, Input } from '@angular/core';
import { AlertLogLevel } from '@app/shared/models/alert-log.model';

@Component({
  selector: 'app-report-message',
  templateUrl: './report-message.component.html',
  styleUrls: ['./report-message.component.scss'],
  standalone: false,
})
export class ReportMessageComponent {
  protected readonly Color = Color;

  @Input() type: AlertLogLevel = AlertLogLevel.INFO;

  @Input() message: string = '';

  @Input() backgroundColor: Color | undefined;

  getPhosphorClassAndColor(): { class: string; color: Color } {
    switch (this.type) {
      case AlertLogLevel.ERROR:
        return { class: 'ph-warning-circle', color: Color.danger500 };
      case AlertLogLevel.WARNING:
        return { class: 'ph-warning', color: Color.warning500 };
      case AlertLogLevel.INFO:
        return { class: 'ph-info', color: Color.info500 };
      default:
        return { class: 'ph-info', color: Color.info500 };
    }
  }
}
